import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {ACTION_CATEGORY} from 'constants/AnalyticsConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

export default function CreatePDFButton({onOpenPreview}: {onOpenPreview: () => void}): JSX.Element {
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.MINI}
      text="Create PDF"
      onClick={() => {
        analytics.trackEventWithModule(
          {
            module: ANALYTICS_MODULE.MOLBIO,
            action: 'clicked_create_pdf',
            actionCategory: ACTION_CATEGORY.READ,
          },
          ANALYTICS_MODULE.MOLBIO,
          {}
        );
        onOpenPreview();
      }}
    />
  );
}
